import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EditRosterPropertiesPageRoutingModule } from './edit-roster-routing.module';

import { EditRosterPropertiesPage } from './edit-roster.page';
import { BhInputComponentModule } from 'src/app/components/_core/bh-input/bh-input.component.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    EditRosterPropertiesPageRoutingModule,
    BhInputComponentModule,
    PipesModule
  ],
  declarations: [EditRosterPropertiesPage]
})
export class EditRosterPageModule {}
